import {createSlatePlugin} from "@udecode/plate";

export const IframePlugin = createSlatePlugin( {
    key: "IFRAME",
    node: {
        isElement: true,
    },
    parsers: {
        html: {
            deserializer: {
                rules: [{
                    validNodeName: "IFRAME"
                }],
                parse: ({ element, type }) => {
                    const {width, height, src, title} = element as HTMLIFrameElement;
                    return {
                        type,
                        attributes: {
                            width,
                            height,
                            src,
                            title,
                        }
                    }
                },
            }
        }
    }
})